<template lang="pug">
  div
    form.col-12(v-on:submit.prevent="shopifyUrl")
      .carrier.card.shadow(v-if="channelInfo.type == 'shopify'")
        .card-header.py-3
          h3.m-0.font-weight-bold.text-primary() Update Shopify Info
          i.nav-item.fas.fa-fw.fa-times.closeModal.pointer( @click="closeModal()")
        .card-body
          .row
            .col-12
              label Your Shopify Store nickname
              br
              input.col-6(required type="text", placeholder="My Toys" v-model="channelInfo.nickname")
            .col-12
              label Your Store Return Policy
              br
              textarea-autosize.col-12(v-model="channelInfo.policy") 
            .col-12
              label Charge
              br
              currency-input(required v-model="channelInfo.charge")
            .col-12
              label Period
              br
              input(required type="text" v-model="channelInfo.period")   
            .col-12.text-right         
              button.btn.btn-primary( ) Save
    form.col-12(v-on:submit.prevent="updateInfo")
      .carrier.card.shadow(v-if="channelInfo.type == 'custom'")
        .card-header.py-3
          h3.m-0.font-weight-bold.text-primary() Update Custom Store Info
          i.nav-item.fas.fa-fw.fa-times.closeModal.pointer( @click="closeModal()")
        .card-body
          .row
            .col-12()
              label Store Name
              br
              input( required type="text", placeholder="name" v-model="channelInfo.nickname")
          .row
            .col-12
              label Store URL
              br
              input(
                required
                type="text", placeholder="https://SHOP-NAME.com" 
                v-model="channelInfo.store")
          .row  
            .col-12
              label Return Policy
              br
              textarea-autosize.col-12(v-model="channelInfo.policy")
          .row
            .col-12
              label Return Period
              br
              input(required type="text" v-model="channelInfo.period")
          .row  
            .col-12
              label Charge
              br
              currency-input(v-model="channelInfo.charge")
              //- input(type="text", )
          .row  
            .col-12.text-right
              button.btn.btn-primary() Save

    transition( name="fade")
      .col-12
        .carrier.card.shadow.mb-4(v-if="platform == 'woocommerce'")
          .card-header.py-3
            h3.m-0.font-weight-bold.text-primary() WooCommerce
          .card-body
            h1 WooCommerce stuff goes here


</template>

<script>
export default {
  name: 'UpdatePlatform',
  components: {
    
  },
  props:{
    gandalf:Boolean,    
    channelInfo:Object,
  },
  data:function(){
    return{

      platform:false,
      woocommerce:{
        selected:false
      },
      custom:{
        selected:false,
        url:null,
      },
      shopify:{
        step:0,
        selected:false,
        client_id:null,
        url:null,
        scope:null,
      }      
    }
  },
  watch:{
    woocommerce: {
      handler() {
        // localStorage.setItem('woocommerce', JSON.stringify(this.woocommerce));
      },
      deep: true,
    },
    shopify: {
      handler() {
        // localStorage.setItem('shopify', JSON.stringify(this.shopify));
      },
      deep: true,
    },
  },
  methods:{
    platformSelect(platform){
      this.woocommerce.selected = false;
      this.shopify.selected = false;      
      this.platform = platform;
      this[platform].selected = true;
    },
    async updateInfo(){
      try {
        let bodyFormData = new FormData();
        bodyFormData.append('channelId', this.channelInfo._id);
        bodyFormData.append('nickname', this.channelInfo.nickname);
        bodyFormData.append('storeUrl', this.channelInfo.store);
        bodyFormData.append('policy', this.channelInfo.policy);
        bodyFormData.append('charge', this.channelInfo.charge);
        bodyFormData.append('period', this.channelInfo.period);
        this.flash('Saving...', 'info');

        const response = await this.axios.post(`/rp/server/connections/custom/update`, bodyFormData);
        const { api_channel, error } = response.data;
        if(api_channel) {
          await this.flash('Saved !', 'success');
          this.$emit('closeForm');
        } else {
          const { message } = error;
          this.flash(message, 'error');
        }
      } catch (error) {
        this.flash(error, 'error');
      }
    },
    async shopifyUrl(){
      var bodyFormData = new FormData();      
      bodyFormData.append('channelId', this.channelInfo._id); 
      bodyFormData.append('nickname', this.channelInfo.nickname); 
      bodyFormData.append('policy', this.channelInfo.policy); 
      bodyFormData.append('charge', this.channelInfo.charge); 
      bodyFormData.append('period', this.channelInfo.period);

      var response = await this.axios.post('/rp/server/connections/shopify/update', bodyFormData)
      if (response.data.error) {
        this.flash( response.data.error.message, 'error')        
      }else{
        this.flash('Shopify Info Updated', 'success')
      }

    },
    async shopifyAuth(){
     
    },
    async closeModal(){
      this.$emit('closeForm')
    },
    async reset(){
      this.woocommerce.selected = false;
      this.shopify.selected = false;   
      this.shopify.step = 0;
      this.woocommerce.step = 0;
      this.platform = null;
      this.$router.push({path:`/dashboard/wizard/2`})
      
      // this.platform = platform;
      // this[platform].selected = true;
    }
    
  },
  mounted(){
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeForm");
      }
    };   
  }
}
</script>
<style lang="scss" scoped>
  input{
    margin:0px 0 20px 0;
  }
  .closeModal{
    position:absolute;
    right:20px;
    top:20px;
  }
  .row{
    margin-bottom:20px;
  }
  .card.selected{
    background-color:rgba(0,0,0,.1);      
  }  
  .card.active{
    height:150px;
  }

  .card{
    // height:200px;
    transition:height .2s;
    margin-top:20px;  
    img{
      height:100%;
      width:auto;
    }
  }
  .fade-enter-active {
    transition: opacity .4s;
  }
  .fade-leave-active {
    display:none;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>
